export const SITE_URL = "fashion.maximquiz.com";
